import React from "react";
import PropTypes from "prop-types";
import Image from "next/image";

import { Container } from "./styled";

const ImageCard = ({ imgSrc }) => {
  return (
    <Container>
      <Image
        alt={`image_slider_${imgSrc}`}
        src={imgSrc || "/images/home_page/banner.png"}
        layout="fill"
        objectFit="cover"
        loading="lazy"
        quality={100}
      />
    </Container>
  );
};

ImageCard.propTypes = {
  imgSrc: PropTypes.string,
};

export default ImageCard;
